import { render } from "./leaves-search-filter.vue?vue&type=template&id=b65b0d98"
import script from "./leaves-search-filter.vue?vue&type=script&lang=js"
export * from "./leaves-search-filter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__